import { INITIALIZED, INITIALIZATION_ERROR } from "../actions/initialize";

const DEFAULT_STATE = {
  initialized: false,
  message: ""
};

const currentUser = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case INITIALIZED:
      return {
        initialized: true,
        message: action.message
      };
    case INITIALIZATION_ERROR:
      return {
        initialized: false,
        message: action.message
      };
    default:
      return state;
  }
};

export default currentUser;
